import React from 'react';
export const Clock = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9536 5.63403C11.9536 5.21982 11.6178 4.88403 11.2036 4.88403C10.7894 4.88403 10.4536 5.21982 10.4536 5.63403V13.455C10.4536 13.7235 10.5971 13.9714 10.8298 14.1052L16.1259 17.1502C16.485 17.3566 16.9435 17.2329 17.15 16.8738C17.3564 16.5147 17.2327 16.0562 16.8736 15.8498L11.9536 13.0211V5.63403Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9996 0.225037C5.49646 0.225037 0.224609 5.49688 0.224609 12C0.224609 18.5032 5.49646 23.775 11.9996 23.775C18.5028 23.775 23.7746 18.5032 23.7746 12C23.7746 5.49688 18.5028 0.225037 11.9996 0.225037ZM1.72461 12C1.72461 6.32531 6.32488 1.72504 11.9996 1.72504C17.6743 1.72504 22.2746 6.32531 22.2746 12C22.2746 17.6748 17.6743 22.275 11.9996 22.275C6.32488 22.275 1.72461 17.6748 1.72461 12Z"
}));